import React from 'react'

import { Badge } from '@aws-amplify/ui-react'


import * as models from '@mytmpvpn/mytmpvpn-common/models/vpn'

import { VpnWithMetrics } from '../../pages/Home'

const TERMINAL_VPN_STATE = [models.VpnState.Running, models.VpnState.Failed, models.VpnState.Deleted, models.VpnState.Paused]

export function isTerminalState(state: models.VpnState) {
  return TERMINAL_VPN_STATE.includes(state)
}

export function VpnState({ vpnWithMetrics }: { vpnWithMetrics: VpnWithMetrics }) {
  return <Badge
    size="small"
    style={{ display: 'inline-flex', alignItems: 'center', gap: '0.25rem' }}
    variation={vpnWithMetrics.state === models.VpnState.Running ? 'success' :
      vpnWithMetrics.state === models.VpnState.Failed ? 'error' : 'info'}>
    {!isTerminalState(vpnWithMetrics.state) && '⏳'}{vpnWithMetrics.state}
  </Badge>
}
